import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { formatDate } from "../../utils/helperFunction";
import { JobType, skillsUsed } from "../../utils/constants";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";
import { getJobById, jobSeen } from "../../endpoints/job.service";
import { jobMatchesSkills } from "../../endpoints/candidate.service";

const tabs = [
  {
    title: "View Job",
    value: "View Job",
  },

  {
    title: "Skills Match",
    value: "Skills Match",
  },
];

const JobMatchedDetailPage = () => {
  const location = useLocation();
  const { item } = location.state || {};
  const jobId = item?.jobId;
  const candidateId = item?.candidateId;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [jobDetails, setJobDetails] = useState();
  const [matchSkills, setMatchSkills] = useState();
  const [activeTab, setActiveTab] = useState("description");
  const [activeDetailTab, setActiveDetailTab] = useState("View Job");
  const job = JobType.find((x) => x.value === jobDetails?.jobType)?.label;

  useEffect(() => {
    fetchJobMatcheSkills();
    jobSeen({ jobId: jobId });
  }, []);

  useEffect(() => {
    fetchJob();
  }, []);

  const fetchJob = async () => {
    try {
      const { success, data } = getJobById({jobId});

      if (success) {
        setJobDetails(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchJobMatcheSkills = async () => {
    try {
      const { data, success } = await jobMatchesSkills(candidateId, jobId);

      if (success) {
        setMatchSkills(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="flex bg-white flex-col rounded-lg w-full gap-8 py-4 px-8 ">
      <div className="flex items-center border-b border-gray-300 gap-16 mt-5 pb-2 pl-4 ">
        {tabs?.map((tab) => {
          const isActive = tab?.value === activeDetailTab;
          return (
            <button
              key={tab?.value}
              onClick={() => setActiveDetailTab(tab?.value)}
              className={`flex items-center ${
                isActive
                  ? "border-b border-primary"
                  : "border-b border-transparent"
              }`}
            >
              <span
                className={`text-xs pb-0.5 ${
                  isActive ? "text-primary font-medium" : "text-gray-500"
                }`}
              >
                {tab?.title}
              </span>
            </button>
          );
        })}
      </div>
      {loading ? (
        <div className="flex items-center justify-center h-full">
          <LoadingAnimation color={"black"} />
        </div>
      ) : (
        <>
          {activeDetailTab === "View Job" ? (
            <>
              <div className="flex flex-1 flex-col max-h-fit overflow-y-scroll no-scrollbar border border-[##DADCE0] px-6 py-10 rounded-sm gap-3.5 w-[60%] ">
                <div className="flex justify-between items-center mb-12 ">
                  <p className="font-medium text-xs text-light-black italic">
                    Posted{" "}
                    <span className="pl-3">
                      {formatDate(jobDetails?.updatedAt)}
                    </span>
                  </p>
                  <div className="flex gap-2">
                    <button
                      className="flex justify-center font-medium text-xs text-white border-[#4D4D4D] rounded-lg bg-[#6F6F6F] px-8 py-2 items-center gap-2"
                      onClick={() => navigate(`${jobId}`)}
                    >
                      Apply
                    </button>

                    <button className="flex justify-center font-medium bg-[#F1F5F9] text-xs text-primary rounded-lg border border-[#ECECEC] px-8 py-2 items-center gap-2">
                      Refer
                    </button>

                    <button className="flex justify-center font-medium bg-[#F1F5F9] text-xs text-primary rounded-lg border border-[#ECECEC] px-8 py-2 items-center gap-2">
                      Track
                    </button>
                  </div>
                </div>

                <div className="flex flex-col flex-1 gap-6">
                  <div className="flex justify-between items-center ">
                    <p className="font-semibold text-primary text-xl">
                      {jobDetails?.title}
                    </p>
                    <span className="font-medium text-light-black text-xs">
                      {jobDetails?.refNo}
                    </span>
                  </div>

                  <div className="flex flex-col gap-2 mb-6">
                    <div className="flex gap-5">
                      <span className="text-xs text-light-black w-28">
                        Agency:
                      </span>
                      <span className="font-medium text-primary text-xs flex-1">
                        {/* {selectedJob?.companyDetails?.name ?? "N/A"} */}
                      </span>
                    </div>
                    <div className="flex gap-5">
                      <span className="text-xs text-light-black w-28">
                        Location:
                      </span>
                      <span className="font-medium text-primary text-xs flex-1">
                        {jobDetails?.location}
                      </span>
                    </div>
                    <div className="flex gap-5">
                      <span className="text-xs text-light-black w-28">
                        Industry Type:
                      </span>
                      <span className="font-medium text-primary text-xs flex-1">
                        {jobDetails?.industryType}
                      </span>
                    </div>
                    <div className="flex gap-5">
                      <span className="text-xs text-light-black w-28">
                        Job Type:
                      </span>
                      <span className="font-medium text-primary text-xs flex-1">
                        {job}
                      </span>
                    </div>
                    <div className="flex gap-5">
                      <span className="text-xs text-light-black w-28">
                        Salary Range:
                      </span>
                      <span className="font-medium text-primary text-xs flex-1">
                        £{jobDetails?.salary.min} - £{jobDetails?.salary.max}
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex space-x-12 mb-6 mt-3 bg-[#F1F5F9] rounded p-4">
                    <button
                      onClick={() => setActiveTab("description")}
                      className={`py-1 px-4 text-xs font-semibold ${
                        activeTab === "description"
                          ? "border-b border-[#2E2E2E] text-primary"
                          : "text-[#6f6f6f] border-b border-transparent"
                      }`}
                    >
                      Job Description
                    </button>
                    <button
                      onClick={() => setActiveTab("skills")}
                      className={`py-1 px-4 text-xs font-semibold ${
                        activeTab === "skills"
                          ? "border-b border-[#2E2E2E] text-primary"
                          : "text-[#6f6f6f] border-b-2 border-transparent"
                      }`}
                    >
                      Skills Required
                    </button>
                  </div>

                  {activeTab === "description" && (
                    <div className="my-3">
                      <span className="font-semibold text-primary text-sm">
                        Job description
                      </span>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: jobDetails?.description,
                        }}
                        className="text-light-black text-xs mt-2"
                      />
                    </div>
                  )}

                  {activeTab === "skills" && jobDetails?.skills?.length > 0 && (
                    <div className="w-3/4">
                      <div className="grid flex-1 mt-7 mb-2 justify-center grid-cols-[1.9fr_0.75fr_0.6fr_1fr]">
                        {["Required skill", "Rating", "Years", "When"].map(
                          (label) => (
                            <span
                              key={label}
                              className="text-xs font-semibold text-gray-700 flex-1"
                            >
                              {label}
                            </span>
                          )
                        )}
                      </div>
                      <div className="overflow-auto h-full">
                        {jobDetails?.skills?.map((skill) => {
                          const lastUsed = Object.entries(skillsUsed).find(
                            ([key, value]) => value === skill.lastUsed
                          );
                          return (
                            <div
                              key={skill?._id}
                              className="grid space-x-3 py-2.5 items-center w-full justify-center relative grid-cols-[1.7fr_0.68fr_0.58fr_1fr]"
                            >
                              {[
                                skill.title,
                                `${skill.rating}/10`,
                                skill.years,
                                lastUsed ? lastUsed[0] : "N/A",
                              ].map((value, index) => (
                                <div
                                  key={index}
                                  className="border border-[#F0F0F0] bg-[#FAFAFA] px-4 py-2.5 text-xs font-medium text-primary rounded flex flex-1"
                                >
                                  {value}
                                </div>
                              ))}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {matchSkills?.jobMatchesDetails?.map((match, index) => (
                <div key={index} className="flex items-center w-full gap-2">
                  <div className="flex items-center py-4 w-[45%] px-4 text-xs font-semibold bg-[#F1F5F9] border-[#ECECEC] rounded-sm">
                    Your skill set
                  </div>

                  <span className="text-xs px-2 w-[10%] border-b pb-2 font-medium italic text-light-black ">
                    {match?.totalMatchPercentage?.toFixed(2)}% matched
                  </span>

                  <div className="flex justify-between items-center w-[45%] py-4 px-4 bg-[#F1F5F9] gap-4 border-[#ECECEC] rounded-sm">
                    <span className="font-medium text-primary text-xs">
                      {match?.jobDetails?.title}
                    </span>
                    <span className="font-normal text-primary text-xs">
                      {match?.jobDetails?.refNo}
                    </span>
                  </div>
                </div>
              ))}

              <div className="flex flex-col gap-2.5">
                <div className="space-y-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="grid grid-cols-[1fr,0.25fr,0.25fr,1fr] gap-3 w-[80%]">
                      {["Skill", "Rating", "Years", "When"].map((label) => (
                        <span
                          key={`candidate-${label}`}
                          className="text-xs font-semibold text-gray-700"
                        >
                          {label}
                        </span>
                      ))}
                    </div>
                    <div className="w-[20%]" />
                    <div className="grid grid-cols-[1fr,0.25fr,0.25fr,1fr] gap-3 w-[80%]">
                      {["Skill", "Rating", "Years", "When"].map((label) => (
                        <span
                          key={`job-${label}`}
                          className="text-xs font-semibold text-gray-700"
                        >
                          {label}
                        </span>
                      ))}
                    </div>
                  </div>

                  {matchSkills?.skillsMatchesDetails?.map((skill, index) => {
                    const getLastUsedLabel = (value) =>
                      Object.entries(skillsUsed).find(
                        ([_, v]) => v === value
                      )?.[0] || "N/A";

                    const candidateSkillData = [
                      skill?.candidateSkill?.title,
                      `${skill?.candidateSkill?.rating}/10`,
                      skill?.candidateSkill?.years,
                      getLastUsedLabel(skill?.jobSkill?.lastUsed),
                    ];

                    const requiredSkillData = [
                      skill?.jobSkill?.title,
                      `${skill?.jobSkill?.rating}/10`,
                      skill?.jobSkill?.years,
                      getLastUsedLabel(skill?.candidateSkill?.lastUsed),
                    ];

                    return (
                      <div
                        key={index}
                        className="flex items-center w-full justify-between gap-4"
                      >
                        <div className="grid grid-cols-[1fr,0.25fr,0.25fr,1fr] gap-2 w-[82%]">
                          {candidateSkillData.map((value, idx) => (
                            <div
                              key={idx}
                              className="border border-[#F0F0F0] bg-[#FAFAFA] px-4 py-2.5 text-xs font-medium text-primary rounded"
                            >
                              {value}
                            </div>
                          ))}
                        </div>
                        <div className="w-[16%] flex items-center justify-center">
                          <span className="text-[10px] border-b pb-2 font-medium italic text-light-black">
                            {skill?.matchingPercentage?.toFixed(2)}% matched
                          </span>
                        </div>

                        <div className="grid grid-cols-[1fr,0.25fr,0.25fr,1fr] gap-2 w-[82%]">
                          {requiredSkillData.map((value, idx) => (
                            <div
                              key={idx}
                              className="border border-[#F0F0F0] bg-[#FAFAFA] px-4 py-2.5 text-xs font-medium text-primary rounded"
                            >
                              {value}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default JobMatchedDetailPage;
